import React from "react";
import { CustomList } from "components/index";
import { ROUTE } from "@/lib/utils";
import { DateCell } from "@/components/date/cell";
import { EmployeeCell } from "components/cell/employee/cell";
import OngoingJobsFilters from "../filter";
import { CURRENT_MONTH_END_DATE, CURRENT_MONTH_START_DATE } from "@/lib/utils";

const JobOngoingFixed = () => {
  const columns = [
    {
      header: "Job",
      id: "name",
      accessorKey: "name",
      meta: {
        spanRow: true,
      },
      // cell: ({ getValue }) => (
      //   <div className="font-semibold text-primary">{getValue()}</div>
      // ),
    },
    {
      header: "Project",
      id: "project_name",
      accessorKey: "project_name",
      meta: {
        spanRow: true,
      },
      // cell: ({ getValue }) => (
      //   <div className="font-semibold text-primary">{getValue()}</div>
      // ),
    },

    {
      header: "Start Date",
      id: "start_date",
      accessorKey: "start_date",
      cell: DateCell,
      meta: {
        spanRow: true,
      },
    },
    {
      header: "End Date",
      id: "end_date",
      accessorKey: "end_date",
      cell: DateCell,
      meta: {
        spanRow: true,
      },
    },
    {
      header: "Extended",
      id: "extended_date",
      accessorKey: "extended_date",
      cell: DateCell,
      meta: {
        spanRow: true,
      },
    },
    {
      header: "Department",
      id: "department",
      meta: {
        subRowAccessor: true,
      },
      cell: ({ row }) => {
        const isDept = !row.original?.start_date;
        if (!isDept) return null;
        console.log(row)
        return <div className="capitalize">{row.original?.name}</div>;
      },
    },
    {
      header: "Employees",
      id: "employee",
      meta: {
        subRowAccessor: true,
      },
      cell: ({ row }) => {
        const isDept = !row.original?.start_date;
        const employees = row.original?.employees;
        if (!isDept || !employees || employees.length === 0) return null;
        return (
          <div className="flex -space-x-1.5 overflow-hidden">
            {employees?.map((employee) => (
              <EmployeeCell key={employee.id} getValue={() => employee} />
            ))}
          </div>
        );
      },
    },
  ];

  const defaultFilters = {
    startDate: CURRENT_MONTH_START_DATE,
    endDate: CURRENT_MONTH_END_DATE,
  };

  const getSubRows = (row) => row.departments;

  const defaultHref = (item) => ROUTE.JOB(item.id);

  return (
    <CustomList
      title={"Fixed Jobs"}
      endPoint="custom-ui/active-fixed-job"
      columns={columns}
      filters={defaultFilters}
      renderFilters={OngoingJobsFilters}
      teleportFilters={true}
      getSubRows={getSubRows}
      href={defaultHref}
      sortBy={"name"}
      showSearch={true}
      hidePagination={true}
      perPage={300}
      storageKey={`fixed-jobs`}
    />
  );
};

export default JobOngoingFixed;
